<template>
  <div class="login">
    <div class="form container">
      <div class="row">
        <div class="col-xs-12 margin-bottom-form-field">
          <input v-model="form.username" :class="`tb ${errors.username.length ? 'error' : ''}`" type="text" placeholder="Korisničko ime ili email" />
          <p class="registration-error" v-if="errors.username.length">{{ errors.username }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 margin-bottom-form-field" style="position: relative">
          <input
            v-model="form.password"
            :class="`tb ${errors.password.length ? 'error' : ''}`"
            :type="isVisible ? 'text' : 'password'"
            placeholder="Lozinka"
          />
          <img
            :src="isVisible ? eyeIcons.visible : eyeIcons.hidden"
            class="hidden-eye"
            v-bind:style="changePasswordEyeStyle()"
            alt=""
            @click="handleVisibility"
          />
          <p class="registration-error" v-if="errors.password.length">{{ errors.password }}</p>
        </div>
        <p class="forgot-password" @click="forgotPassword()">Zaboravljena lozinka?</p>
      </div>
    </div>

    <p class="error-text">{{ getLoginErrorMessage }}</p>
    <div class="submit">
      <button class="btnSubmit" :disabled="isLoadingLogin" @click="handleLogin()">
        {{ isLoadingLogin ? "Učitavanje..." : "Ulogujte se" }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import { mapGetters } from "vuex";

@Options({
  computed: {
    ...mapGetters(["getLoginErrorMessage", "isLoadingLogin"]),
  },
})
export default class Login extends Vue {
  form = {
    username: "",
    password: "",
  };
  errors = {
    username: "",
    password: "",
  };
  eyeIcons = {
    hidden: require("../assets/images/hidden.png"),
    visible: require("../assets/images/show.png"),
  };
  isVisible = false;
  badRequestErrorMessages = {
    username: "Korisničko ime nije odgovarajuće",
    password: "Pogresna lozinka",
  };
  conflictingErrorMessages = {
    username: "Korisnik ne postoji",
    password: "Pogresna lozinka",
  };

  public getLoginErrorMessage: any;
  public isLoadingLogin: any;

  handleVisibility() {
    this.isVisible = !this.isVisible;
  }

  changePasswordEyeStyle() {
    return this.errors.password === ""
      ? {
          transform: "translateY(-50%)",
        }
      : {
          transform: "translateY(-100%)",
        };
  }

  async handleLogin() {
    if (!this.validateForm()) {
      return;
    }

    this.errors.username = "";
    this.errors.password = "";

    try {
      await store.dispatch("login", this.form);

      this.form.password = "";
      this.form.username = "";
      this.$router.push("/auth-successful");
    } catch (error: any) {
      if (!("status" in error) || !("data" in error)) return;

      const status = error.status as number;
      const data = error.data as [keyof typeof this.errors];
      for (const key of data) {
        if (status === 400) {
          this.errors[key] = this.badRequestErrorMessages[key];
        } else if (status === 409) {
          this.errors[key] = this.conflictingErrorMessages[key];
        }
      }
    }
  }

  validateForm() {
    this.errors = {
      username: "",
      password: "",
    };
    if (!this.form.username) this.errors.username = "Polje je obavezno";
    if (!this.form.password) this.errors.password = "Lozinka je obavezna";

    const hasErrors = Object.values(this.errors).some((value) => value !== "");
    return !hasErrors;
  }

  forgotPassword() {
    this.$router.push("/forgot-password");
  }
}
</script>
<style scoped>
@media (max-width: 480px) {
  .hidden-eye {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 30px;
    width: 24px;
  }

  .error-text {
    color: red;
    font-size: 14px;
    margin-top: 0px;
    font-weight: normal;
    text-transform: none;
    text-align: center;
  }

  .forgot-password {
    text-decoration: underline;
    color: white;
    text-align: right;
    margin-right: 15px;
  }

  input {
    color: rgba(156, 156, 156, 1) !important;
    padding-left: 18px;
    font-size: 18px;
  }
  .form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .tb {
    height: 60px;
    width: 326px;
    gap: 0px;
    border-radius: 5px;
    margin: 0 auto;
    background: rgba(35, 35, 35, 1);
  }

  .tb-half {
    height: 60px;
    border-radius: 5px;
    margin: 0 auto;
    width: 150px;
    background: rgba(35, 35, 35, 1);
  }

  .submit {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .btnSubmit {
    width: 70% !important;
    height: 67px !important;
    padding: 16px 69px 16px 69px !important;
    gap: 8px !important;
    border-radius: 8px !important;
    color: white !important;
    background: rgba(24, 171, 63, 1) !important;
    box-shadow: 0px 9px 16px 0px rgba(214, 255, 200, 0.45) inset !important;
    box-shadow: 0px -6px 10px 0px rgba(0, 98, 3, 0.52) inset !important;
  }

  .btnSubmit:disabled {
    opacity: 0.6 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
  }

  .margin-bottom-form-field {
    margin-bottom: 10px !important;
  }

  .registration-error {
    color: red !important;
    font-size: 14px !important;
    margin-top: 0px !important;
    font-weight: normal !important;
    text-transform: none !important;
    text-align: left !important;
  }

  .error {
    border: 1px solid red;
  }
}
</style>
